import { initializeApp, type FirebaseOptions } from 'firebase/app'
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics'

const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)
let analyticsInstance: Analytics | null = null

const initFirebaseAnalytics = async (): Promise<Analytics | null> => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    if (!analyticsInstance) {
      const supported = await isSupported()
      if (supported) {
        analyticsInstance = getAnalytics(app)
      } else {
        console.warn('Firebase Analytics is not supported in this environment')
      }
    }
    return analyticsInstance
  } catch (error) {
    console.error(
      `Failed to check Firebase Analytics support: ${JSON.stringify(
        error,
        null,
        2,
      )}`,
    )
    return null
  }
}

export { app, initFirebaseAnalytics }
